export default __webpack_public_path__ + "static/media/Group -6TataNeu.aeb31cca.png";